import { render, staticRenderFns } from "./indexPassengers.vue?vue&type=template&id=81755c48&"
import script from "./indexPassengers.vue?vue&type=script&lang=ts&"
export * from "./indexPassengers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports